import { t } from "@/i18n-js/instance";
import { Filter } from "@/react/components/FilterKit/Filter";
import { useFilterProvider } from "../../../FilterKit/FilterProvider";

export const FilterBar = () => {
  const { configurations, isLoading } = useFilterProvider();

  if (isLoading) {
    return <div>{t("toggle_with_loader.loading")}</div>;
  }

  const searchFilter = configurations.find(c => c.input_type === "search");
  const otherFilters = configurations.filter(c => c.input_type !== "search");

  return (
    <div className="flex flex-col gap-3">
      {searchFilter && (
        <Filter key={searchFilter.key} configuration={searchFilter} />
      )}
      <div className="flex flex-wrap items-center gap-2">
        {otherFilters.map(config => (
          <Filter key={config.key} configuration={config} />
        ))}
      </div>
    </div>
  );
};
